import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = 'white'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#696969',
        backgroundColor: '#696969',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 15,
        fontSize:9,
        fontFamily:'Helvetica-Bold',
        fontSize:7,
        color:'white',
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,

    },
    description: {
        width: '10%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    sn: {
        width: '5%',
    },
    qty: {
        width: '20%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    rate: {
        width: '20%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    amount: {
        width: '30%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    },
    prev1: {
        width: '15%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1
    }
  });

  const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.sn}>S/N</Text>
        <Text style={styles.description}>Invoice ID</Text>
        <Text style={styles.qty}>Name</Text>
        <Text style={styles.rate}>Age</Text>
        <Text style={styles.amount}>Test Name</Text>
        <Text style={styles.prev1}>Sample Date & Time</Text>
  
    </View>
  );
  
  export default InvoiceTableHeader